import { EuroValue, values } from '@dokucoach/common-types';
import { InsuranceCostAbsorptionLevel, Supplement43cLevel } from '@dokucoach/invoicing-types';
import { boolean, date, mixed, object, string } from 'yup';

export type IResidentInsuranceInvoicingConfig = {
  id: string;
  nursingHomeId: string;
  residentId: string;
  validFrom: Date;
  insuranceId: string;
  costBearerId: string;
  costAbsorptionLevel: InsuranceCostAbsorptionLevel;
  insuranceNumber: string | null;
  amountNursingAllowance35: number | null;
  supplement43cLevel: Supplement43cLevel | null;
  nextSupplement43cLevelFrom: Date | null;
  isAmountUsedForMonth: boolean | null;
  disableSurcharge132gp3InMoveInMonth?: boolean | null;
  remainingKzpAmount: number | null;
  alreadyUsedVhpAmount: number | null;
  alreadyUsedMonthlyBenefitAmount: number | null;
  alreadyUsedMonthlySurcharge: number | null;
  customCostObjectNumber?: string | null;
  createdAt: Date;
};

export type IResidentInsuranceInvoicingConfigCreate = {
  validFrom: Date;
  insuranceId: string;
  costAbsorptionLevel: InsuranceCostAbsorptionLevel;
  insuranceNumber?: string | null;
  amountNursingAllowance35?: number | null;
  supplement43cLevel?: Supplement43cLevel | null;
  nextSupplement43cLevelFrom?: Date | null;
  isAmountUsedForMonth: boolean | null;
  remainingKzpAmount?: number | null;
  alreadyUsedVhpAmount?: number | null;
  alreadyUsedMonthlyBenefitAmount?: number | null;
  alreadyUsedMonthlySurcharge?: number | null;
  customCostObjectNumber?: string | null;
  disableSurcharge132gp3InMoveInMonth: boolean;
};

export type IResidentInsuranceInvoicingConfigUpdate = IResidentInsuranceInvoicingConfigCreate;

export const IResidentInsuranceInvoicingConfigCreateSchema = object({
  validFrom: date().required(),
  insuranceId: string().required(),
  costAbsorptionLevel: mixed<InsuranceCostAbsorptionLevel>()
    .oneOf(values(InsuranceCostAbsorptionLevel))
    .required(),
  insuranceNumber: string().required(),
  amountNursingAllowance35: EuroValue.nullable().optional(),
  supplement43cLevel: mixed<Supplement43cLevel>()
    .oneOf([null, undefined, ...values(Supplement43cLevel)])
    .nullable()
    .optional(),
  nextSupplement43cLevelFrom: date().nullable().optional(),
  isAmountUsedForMonth: boolean().nullable().optional(),
  remainingKzpAmount: EuroValue.nullable().optional(),
  alreadyUsedVhpAmount: EuroValue.nullable().optional(),
  alreadyUsedMonthlyBenefitAmount: EuroValue.nullable().optional(),
  alreadyUsedMonthlySurcharge: EuroValue.nullable().optional(),
  customCostObjectNumber: string().nullable().optional(),
});

export const IResidentInsuranceInvoicingConfigUpdateSchema =
  IResidentInsuranceInvoicingConfigCreateSchema;
